import BaseRoute from 'seshy/routes/base';
import { action } from '@ember/object';

export default class ProjectsIndexRoute extends BaseRoute {
  searchValue = '';
}
